import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { unitStats } from '../../../stats';

export const academyReducer = (scratch: StatsSnapshot) => {
  const stats = unitStats.academy;
  const generated = stats.unitsGeneration ?? 0;

  scratch.generators.wizard.owned += generated;

  return;
};
